import React from "react";
import { ChatCategory } from "services/ChatApi";
import { PlannerLogo } from "ui/Icons";
import { RHPCategoryCard } from "./RHPCategoryCard";
import { ChatMode } from "../hooks/useChatState";
import { RHPPrompt } from "./RHPPrompt";
import { useSelector } from "react-redux";
import { isInternalUser } from "store/modules/auth";

export interface IRHPNoMessages {
  categories: ChatCategory[];
  prompts: string[];
  chatMode: ChatMode;
  selectedCategory: ChatCategory | null;
  selectCategory: (category: ChatCategory) => void;
  selectPrompt: (prompt: string) => void;
  backToCategories: () => void;
  isPromptSelected: boolean;
}

export const RHPNoMessages = (props: IRHPNoMessages) => {
  const { categories, chatMode, prompts, selectedCategory, selectCategory, selectPrompt, backToCategories, isPromptSelected } = props;

  const isInternal = useSelector(isInternalUser);

  if (chatMode === ChatMode.PROMPTS) {
    return (
      <div className="flex flex-col gap-20px w-full">
        <div className="w-full font-pt-sans font-bold flex flex-col gap-10px items-start">
          <div className="text-brown-prime text-15px cursor-pointer" onClick={backToCategories}> &lt; <span className="underline">Back to categories</span></div>
          <div className="text-black text-17px">Ask about {selectedCategory?.name}</div>
        </div>
        <div className="flex flex-col items-center h-full gap-20px w-full">
          {prompts.map((pro, index) => (
            <RHPPrompt key={index} prompt={pro} selectPrompt={selectPrompt} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col items-center h-fit gap-30px">
        <PlannerLogo />
        <div className="text-brown-prime font-pt-sans">
          <div className="text-center text-21px font-bold">Welcome to Pure AI</div>
          <div className="text-center text-17px">Trained on our Data</div>
        </div>
        <div className="text-center text-black text-15px leading-22px">
          Ask anything, anytime. From tailored itinerary ideas to insider recommendations, hotel brochures to floor plans ...<br />
          Simply type your request and let our AI, which is powered and trained on our very own knowledge base, do the rest.
        </div>
      </div>
      {isInternal && (
        <div className="flex flex-wrap gap-20px mb-20px mt-50px mx-auto w-[930px]">
          {categories.map((category) => (
            <RHPCategoryCard category={category} selectCategory={selectCategory} />
          ))}
        </div>
      )}
    </>
  );
};